import React from 'react';

import { Checkbox, FormControl, FormControlLabel, FormGroup, Grid } from '@mui/material';
import { ICheckboxesGroupProps } from './CheckboxesGroup.types';

export function CheckboxesGroup<T extends object>({
  elements,
  name,
  onChange,
  values,
  mt,
  full = false,
  singleField = false,
  onError
}: ICheckboxesGroupProps<T>) {
  return (
    <FormGroup>
      <Grid container>
        {elements.map(checkboxElement => (
          <Grid item key={checkboxElement.name} mt={mt} xs={full ? 12 : checkboxElement.size ?? 4}>
            <FormControl error={onError}>
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={checkboxElement.disabled}
                    checked={Boolean(values.find(value => checkboxElement.name === value))}
                    onChange={() => onChange(name, checkboxElement.name)}
                    name={checkboxElement.name}
                    sx={{
                      color: onError ? 'error.main' : 'primary.text',
                      '&.Mui-checked': {
                        color: onError ? 'error.main' : 'primary.text'
                      }
                    }}
                  />
                }
                label={checkboxElement.label}
              />
            </FormControl>
          </Grid>
        ))}
      </Grid>
    </FormGroup>
  );
}
